import React from 'react'
import { TransactionMoreWrapper } from '../transactionListHeadingStyle'
import { TransactionListing } from './TransactionListing'

const TransactionHeading = () => {
  return (
    <TransactionMoreWrapper>
      <div className="transactionHeading lg">
        <div className="description">
          <p className="title">Description</p>
        </div>
        <div className="amount">
          <p className="title">Amount</p>
        </div>
        <div className="date">
          <p className="title">Date</p>
        </div>
        <div className="type">
          <p className="title">Type</p>
        </div>

        <div className="status">
          <p className="title">Status</p>
        </div>
      </div>
      <TransactionListing />
    </TransactionMoreWrapper>
  )
}

export { TransactionHeading }
